import 'PublicPath';

import { ssrHypernova } from 'ssr/hypernova/ssrHypernova';

import MainApp from './MainApp.dynamic';
import { configureMainStore } from './store/configureMainStore';

export default ssrHypernova('main', MainApp, configureMainStore);
